import { FC, ReactNode } from "react";
import "./Card.scss";

interface CardProps {
  children: ReactNode | string;
  customClass?: string;
}

const Card: FC<CardProps> = ({ children, customClass }) => (
  <div className={`bg-default card ${customClass}`}>
    {children}
  </div>
);

export default Card;

Card.defaultProps = {
  customClass: "",
};
